import script from "./posReportPage.vue?vue&type=script&setup=true&lang=js"
export * from "./posReportPage.vue?vue&type=script&setup=true&lang=js"

import "./posReportPage.vue?vue&type=style&index=0&id=15a4e467&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15a4e467"]])

export default __exports__